import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { RouteDeductionDetailsReport } from './Pages/listing';

export const RouteDeductionDetailsReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={RouteDeductionDetailsReport} />
    </Fragment>
)